export enum PaymentFlowStatus {
  Unknown,
  Created,
  Initiated,
  Success,
  Error,
  ReimbursementToClientFromDigiteal,
  ReimbursementToClientFromRequestor,
}
